<template>
  <div class="question4">
    <div class="question4_container">
      <h4 class="bold colorWhite">地震後，<br>你家柱子出現的最明顯裂痕</h4>
      <div class="question4_container_radios">
        <div class="question4_container_radio" :class="{'question4_container_radio-active': isActive1}" @click="radio_click('isActive1')">
          <div class="question4_container_radio_circle"></div>
          <div class="question4_container_radio_imageContainer">
            <img class="question4_container_radio_imageContainer_image" src="static/image/q4_1.svg" alt="柱子">
          </div>
          <span>柱子有連續的垂直向開裂</span>
        </div>
        <div class="question4_container_radio" :class="{'question4_container_radio-active': isActive2}" @click="radio_click('isActive2')">
          <div class="question4_container_radio_circle"></div>
          <div class="question4_container_radio_imageContainer">
            <img class="question4_container_radio_imageContainer_image" src="static/image/q4_2.svg" alt="柱子">
          </div>
          <span>柱子有連續的斜向開裂</span>
        </div>
        <div class="question4_container_radio" :class="{'question4_container_radio-active': isActive3}" @click="radio_click('isActive3')">
          <div class="question4_container_radio_circle"></div>
          <div class="question4_container_radio_imageContainer">
            <img class="question4_container_radio_imageContainer_image" src="static/image/q4_3.svg" alt="柱子">
          </div>
          <span>柱子有連續的X形開裂</span>
        </div>
        <div class="question4_container_radio" :class="{'question4_container_radio-active': isActive4}" @click="radio_click('isActive4')">
          <div class="question4_container_radio_circle"></div>
          <div class="question4_container_radio_imageContainer">
            <img class="question4_container_radio_imageContainer_image" src="static/image/q4_4.svg" alt="柱子">
          </div>
          <span>柱子的鋼筋外露</span>
        </div>
        <div class="question4_container_radio" :class="{'question4_container_radio-active': isActive5}" @click="radio_click('isActive5')">
          <div class="question4_container_radio_circle"></div>
          <div class="question4_container_radio_imageContainer">
            <img class="question4_container_radio_imageContainer_image" src="static/image/q4_5.svg" alt="柱子">
          </div>
          <span>柱子有連續的V形開裂</span>
        </div>
        <div class="question4_container_radio" :class="{'question4_container_radio-active': isActive6}" @click="radio_click('isActive6')">
          <div class="question4_container_radio_circle"></div>
          <div class="question4_container_radio_imageContainer">
            <img class="question4_container_radio_imageContainer_image" src="static/image/q4_6.svg" alt="柱子">
          </div>
          <span>柱子有不連續的垂直向、斜向開裂</span>
        </div>
        <div class="question4_container_radio" :class="{'question4_container_radio-active': isActive7}" @click="radio_click('isActive7')">
          <div class="question4_container_radio_circle"></div>
          <div class="question4_container_radio_imageContainer">
            <img class="question4_container_radio_imageContainer_image" src="static/image/q4_7.svg" alt="柱子">
          </div>
          <span>柱子有細小的水平向裂紋</span>
        </div>
        <div class="question4_container_radio" :class="{'question4_container_radio-active': isActive8}" @click="radio_click('isActive8')">
          <div class="question4_container_radio_circle"></div>
          <div class="question4_container_radio_imageContainer">
            <img class="question4_container_radio_imageContainer_image" src="static/image/q4_8.svg" alt="柱子">
          </div>
          <span>無上述情形</span>
        </div>
      </div>
      <div class="question4_container_btns">
        <router-link to="/question3" class="question4_container_btn bold question4_container_btn-active" title="上一題">上一題</router-link>
        <router-link to="/question5" class="question4_container_btn bold" :class="{'question4_container_btn-active': btnIsActive}" title="下一題" @click.native="click_GA">下一題</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Question4',
  props: {
    bar: Object
  },
  data() {
    return {
      isActive1: false,
      isActive2: false,
      isActive3: false,
      isActive4: false,
      isActive5: false,
      isActive6: false,
      isActive7: false,
      isActive8: false,
      answer: null
    }
  },
  computed: {
    btnIsActive() {
      if (this.answer) {
        return true
      }
      return false
    }
  },
  methods: {
    radio_click(isActive) {
      this.isActive1 = false
      this.isActive2 = false
      this.isActive3 = false
      this.isActive4 = false
      this.isActive5 = false
      this.isActive6 = false
      this.isActive7 = false
      this.isActive8 = false
      this.$data[isActive] = true

      this.answer = isActive

      this.$store.state.answers.answer4 = isActive
      // console.log('$answer4: ' + this.$store.state.answers.answer4)
    },
    detectPlatform() {
      if( navigator.userAgent.match(/Android/i)
          || navigator.userAgent.match(/webOS/i)
          || navigator.userAgent.match(/iPhone/i)
          || navigator.userAgent.match(/iPad/i)
          || navigator.userAgent.match(/iPod/i)
          || navigator.userAgent.match(/BlackBerry/i)
          || navigator.userAgent.match(/Windows Phone/i)
      ){
          return 'Mob';
      }
      else {
          return 'PC';
      }
    },
    click_GA() {
      let number = this.$store.state.answers.answer4.slice(8)
      ga('newmedia.send', {
        hitType: 'event',
        eventCategory: 'Pillar',
        eventAction: 'Click',
        eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [Pillar${number}]`,
      })
      window.scrollTo(0, 0)
    }
  },
  mounted() {
    this.answer = this.$store.state.answers.answer4
    this.$data[this.$store.state.answers.answer4] = true
    if(this.bar){
      this.bar.animate(.8)
      this.bar.text.textContent = '4/5'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
span
  margin: 0
h4
  padding: 2rem 0
.bold
  font-weight: bold
.colorWhite
  color: #fff
.question4
  width: 100%
  min-height: 100vh
  display: flex
  justify-content: center
  align-items: flex-start
  margin: 0 auto
  background: #5b5b5b
  height: 100vh
  @media (min-width: 768px) 
    align-items: flex-end
  @media (min-width: 1280px) 
    width: 880px
    padding: 0 10% 0 10%
    box-sizing: content-box
    height: 100vh
.question4_container
  overflow: auto
  margin: 0 auto
  width: 100%
  min-height: 100vh
  padding: 50px 1rem 0 1rem
  text-align: center
  background-color: #737373
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16)
  border-radius: 10px 10px 0 0
  @media (min-width: 768px) 
    position: relative
    width: 880px
    height: calc(100% - 100px)
    min-height: auto
.question4_container_radio
  width: 100%
  text-align: left
  display: flex
  align-items: center
  padding-left: 1rem
  padding-top: 15px
  padding-bottom: 15px
  color: #fff
  border: 2px solid transparent
  border-bottom: 1px solid #A9A9A9
  margin-bottom: -2px
  cursor: pointer
  @media (min-width: 768px) 
    width: calc(50% - 1rem)
.question4_container_radios
  display: flex
  flex-wrap: wrap
  justify-content: space-between
  animation: ani 1s
.question4_container_radio-active
  border: 2px solid #57af9f
  .question4_container_radio_circle
    background-color: #57af9f
.question4_container_radio_circle
  flex-shrink: 0
  width: 14px
  height: 14px
  border: solid 1px #ffffff
  border-radius: 50%
  display: inline-block

  margin-right: 16px
.question4_container_radio_imageContainer
  flex-shrink: 0
  display: inline-block
  width: 100px
  margin-right: 2rem
.question4_container_radio_imageContainer_image
  width: 100%
.question4_container_btns
  padding: 2rem 0
  width: 100%
  display: flex
  justify-content: space-around
  margin-bottom: 3rem
  opacity: 0
  animation: ani 1s 0.5s forwards
  @media (min-width: 768px) 
    justify-content: center
.question4_container_btn
  display: inline-block
  padding: 5px 2rem
  color: #cfcfcf
  box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16)
  background-color: #A9A9A9
  text-decoration: none
  font-size: 1.25rem
  pointer-events: none
  @media (min-width: 768px) 
    margin: 0 13px
.question4_container_btn-active
  pointer-events: auto
  color: #fff
  background-color: #57af9f
@keyframes ani 
  0%
    transform: translateY(50px)
    opacity: 0
  100%
    transform: translateY(0)
    opacity: 1
</style>
